"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DropdownButton = function (_a) {
    var isActive = _a.isActive, buttonTitle = _a.buttonTitle, onClick = _a.onClick;
    var className = classnames_1.default("gd-mvf-dropdown-button", "s-mvf-dropdown-button", "gd-button", "gd-button-secondary", "button-dropdown", "gd-icon-right", { "gd-icon-navigateup": isActive, "gd-icon-navigatedown": !isActive });
    return (react_1.default.createElement("button", { className: className, onClick: onClick }, buttonTitle));
};
exports.default = DropdownButton;
//# sourceMappingURL=MeasureValueFilterButton.js.map